module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.loaded === false) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n    Loading data..\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/logo.png",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card lol-window"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'reward'
      }
    }
  }, [_vm._v("Reward")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'blocks'
      }
    }
  }, [_vm._v("Blocks")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'tx'
      }
    }
  }, [_vm._v("Tx")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow'
      }
    }
  }, [_vm._v("POW")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'security'
      }
    }
  }, [_vm._v("Security")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "lol-window-inner"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-muted text-center"
  }, [_vm._v("\n              created by\n              "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("trippysalmon")]), _vm._v("\n              / " + _vm._s(_vm.version) + " / blockdata kindly provided by\n              "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://blockchair.com"
    }
  }, [_vm._v("blockchair.com")]), _vm._v(" / exchange rate by\n              "), _c('a', {
    attrs: {
      "href": "http://www.bitcoinaverage.com"
    }
  }, [_vm._v("bitcoinaverage.com")])], 1)])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('notifications')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-light bg-faded lol-nav"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/logo.png",
      "alt": "fork.lol",
      "width": "30",
      "height": "30"
    }
  }), _vm._v(" fork.lol\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cad49406","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 563
// module chunks = 1